import type React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { CapIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface HeadwearAttributeCardProps extends WithDataTestid, WithClassNameProp {
  headwear: 0 | 1 | 2 ;
  color: string | null;
  size?: 'medium' | 'large';
}

export function HeadwearAttributeCard({
  headwear,
  color,
  className = undefined,
  'data-testid': dataTestId = 'HeadwearAttributeCard',
  ...props
}: HeadwearAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  const description = EVENT_ENUMS.UPPER_BODY.HEADWEAR[headwear]?.label;

  const isHeadwearAllowed = headwear !== EVENT_ENUMS.UPPER_BODY.HEADWEAR[0].value
    && headwear !== EVENT_ENUMS.UPPER_BODY.HEADWEAR[2].value;

  const colorsConfig = isHeadwearAllowed
    ? [{ color, tooltip: color ? EVENT_ENUMS.UPPER_BODY.HEADWEAR_COLORS[color]?.label : undefined }]
    : [];

  return (
    <AttributeCard
      className={className}
      colorsConfig={colorsConfig}
      data={headwear !== 2 ? headwear : null}
      data-testid={dataTestId}
      description={description}
      icon={<CapIcon />}
      title={t('shared:attribute_cards.headwear.title')}
      {...props}
    />
  );
}
